var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74307 6.10156L6.93057 2.91406C7.15088 2.69375 7.50713 2.69375 7.7251 2.91406L8.25479 3.44375C8.4751 3.66406 8.4751 4.02031 8.25479 4.23828L5.99776 6.5L8.25713 8.75937C8.47744 8.97968 8.47744 9.33593 8.25713 9.5539L7.72744 10.0859C7.50713 10.3062 7.15088 10.3062 6.93291 10.0859L3.74541 6.89843C3.52276 6.67812 3.52276 6.32187 3.74307 6.10156Z",
    fill: "#5F6468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleleft);
export default __webpack_public_path__ + "static/media/angleleft.2a1773da3357f47c185726cb2502ac02.svg";
export { ForwardRef as ReactComponent };